import { selectIncorrectHelpThreshold } from '../../../accounts/selectors/incorrect-help-threshold.selector.ts';
import { AppStateEnum } from '../../../main/types/app-state.types.ts';
import { TaskType } from '../../../main/types/asset/asset.enums.ts';
import { getReduxStoreUtil } from '../../../main/utils/redux-store.util.ts';

import { selectCurrentLessonTaskStepKey } from '../../selectors/current-lesson-task-step-key.selector.ts';
import { selectCurrentLessonTaskStep } from '../../selectors/current-lesson-task-step.selector.ts';

const AUTO_PASS_LESSON_LIMIT = 2;

export class IncorrectAttemptsUtil {
  private static _instance: IncorrectAttemptsUtil;
  private incorrectAttempts = 0;

  private constructor(private readonly reduxStoreUtil = getReduxStoreUtil()) {}

  public static get instance(): IncorrectAttemptsUtil {
    if (!IncorrectAttemptsUtil._instance) {
      IncorrectAttemptsUtil._instance = new IncorrectAttemptsUtil();
    }
    return IncorrectAttemptsUtil._instance;
  }

  handleStartStep(): void {
    this.incorrectAttempts = 0;
  }

  async handleIncorrectStep(): Promise<AppStateEnum> {
    const state = await this.reduxStoreUtil.getRootState();
    const { task } = selectCurrentLessonTaskStep(state);

    if (task.taskType === TaskType.NewCritter) {
      return AppStateEnum.Retry;
    }

    const incorrectHelpThreshold = selectIncorrectHelpThreshold(state);
    const { lesson: lessonKey } = selectCurrentLessonTaskStepKey(state);

    this.incorrectAttempts++;
    if (this.incorrectAttempts >= incorrectHelpThreshold) {
      this.incorrectAttempts = 0;
      if (lessonKey < AUTO_PASS_LESSON_LIMIT) {
        return AppStateEnum.Correct;
      }

      return AppStateEnum.Helping;
    }
    // Implement task-based retry logic here
    return AppStateEnum.Retry;
  }
}

export const getIncorrectAttemptsUtil = (): IncorrectAttemptsUtil => IncorrectAttemptsUtil.instance;
